import { useEffect } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Banner from './components/Banner';
import Vitrine from './components/Vitrine';
import Footer from './components/Footer';
import PopupModal from './components/PopupModal';
import SvgIcons from './components/SvgIcons';

function App() {
  useEffect(() => {
    const initKey = 'vitrine-react-initialized';

    if (window[initKey]) {
      return;
    }
    window[initKey] = true;

    // Preserve existing classes (like 'dark-mode') and just add our required ones
    ['area', 'home', 'netflix', 'area-vitrine'].forEach(cls => document.body.classList.add(cls));

    const originalErrorHandler = window.onerror;
    const originalUnhandledRejectionHandler = window.onunhandledrejection;

    window.onerror = function(message, source, lineno, colno, error) {
      console.error('Script error caught:', { message, source, lineno, colno, error });
      if (originalErrorHandler) {
        return originalErrorHandler.apply(this, arguments);
      }
      return false;
    };

    window.onunhandledrejection = function(event) {
      console.error('Unhandled promise rejection:', event.reason);
      if (originalUnhandledRejectionHandler) {
        return originalUnhandledRejectionHandler.apply(this, arguments);
      }
      return false;
    };

    const loadScript = (src, checkGlobal = null) => {
      return new Promise((resolve) => {
        try {
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
          }

          if (checkGlobal && window[checkGlobal]) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = src;
          script.onload = () => resolve();
          script.onerror = () => resolve();
          script.addEventListener('error', () => resolve());

          document.head.appendChild(script);
        } catch (error) {
          resolve();
        }
      });
    };

    const initializeScripts = async () => {
      try {
        if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
          const swiperCSS = document.createElement('link');
          swiperCSS.rel = 'stylesheet';
          swiperCSS.href = 'https://unpkg.com/swiper/swiper-bundle.min.css';
          document.head.appendChild(swiperCSS);
        }

        await loadScript('https://unpkg.com/swiper/swiper-bundle.min.js', 'Swiper');

        // Sinaliza para componentes que o Swiper está pronto
        if (window.Swiper) {
          try {
            document.dispatchEvent(new Event('swiper-ready'));
          } catch (_) {}
        }

        if (!window.app) {
          window.app = {
            init: () => {},
            cleanup: () => {}
          };
        }
      } catch (error) {
        if (!window.app) {
          window.app = {
            init: () => {},
            cleanup: () => {}
          };
        }
      }

      if (!window.translations) {
        window.translations = {
          atencao: "Atenção",
          cancelar: "Cancelar",
          deletar: "Deletar",
          continuar: "Continuar",
          salvo: "Salvo",
          nao_informado: "Não Informado",
        };
      }
    };

    initializeScripts();

    return () => {
      window.onerror = originalErrorHandler;
      window.onunhandledrejection = originalUnhandledRejectionHandler;

      if (window.app && window.app.cleanup) {
        window.app.cleanup();
      }
      window[initKey] = false;
    };
  }, []);

  // Data for the vitrines (content sections) - matching original exactly
  const vitrine1Items = [
    {
      href: "/area/produto/item/2078932",
      imageLarge: "/Capas/1.jpg"
    },
    {
      href: "/area/produto/item/5234447",
      imageLarge: "/Capas/2.jpg"
    },
    {
      href: "/area/produto/item/2078941",
      imageLarge: "/Capas/3.jpg"
    },
    {
      href: "/area/produto/item/3893620",
      imageLarge: "/Capas/4.jpg"
    },
    {
      href: "/area/produto/item/2084285",
      imageLarge: "/Capas/5.jpg"
    },
    {
      href: "/area/produto/item/2079374",
      imageLarge: "/Capas/6.jpg"
    },
    {
      href: "/area/produto/item/2079373",
      imageLarge: "/Capas/7.jpg"
    }
  ];

  // eslint-disable-next-line no-unused-vars
  const vitrine2Items = [
    {
      href: "/area/produto/item/2084310",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2084297",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2079361",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2079365",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/4454341",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2084300",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2926567",
      imageLarge: "/logo-trading.png"
    }
  ];

  // eslint-disable-next-line no-unused-vars
  const vitrine3Items = [
    {
      href: "/area/produto/item/2926568",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2079370",
      imageLarge: "/logo-trading.png"
    },
    {
      href: "/area/produto/item/2084304",
      imageLarge: "/logo-trading.png"
    }
  ];

  return (
    <ThemeProvider>
      <div>
        <Header />
        <Banner />
        <Vitrine
          id="45157"
          title="1️⃣ - COMECE POR AQUI"
          items={vitrine1Items}
          showNavigation={true}
        />

        {/* Module 2 and 3 temporarily removed — courses not available yet */}
        {/*
        <Vitrine
          id="47549"
          title="2️⃣ - CONTEÚDOS TÉCNICOS E ESTRATÉGIAS"
          items={vitrine2Items}
          showNavigation={true}
        />
        <Vitrine
          id="47533"
          title="3️⃣ - CONTEÚDOS NA QUOTEX (CORRETORA DE RETRAÇÃO)"
          items={vitrine3Items}
          showNavigation={false}
        />
        */}

        <Footer />
        <PopupModal />
        <SvgIcons />
      </div>
    </ThemeProvider>
  );
}

export default App;
